export default __webpack_public_path__ + "static/media/skipped_icon.d9edb3f7.svg";